import PropTypes from 'prop-types';

const SVG = ({
  style = {
    fill: '#000000',
  },
}) => (
  <svg style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.52 60">
    <path d="M19.34 15.47a.43.43 0 01-.25-.32l-.74-4.54L18.08 9a.42.42 0 00-.43-.36h-1.38a.43.43 0 01-.43-.38L15.05 2l-.2-1.62a.43.43 0 00-.43-.38H9.13a.43.43 0 00-.43.38L8.5 2l-.67 5.25v.24l-.17 1.12H6a.43.43 0 00-.47.39l-.27 1.64-.67 4.15a.44.44 0 01-.34.35A5.45 5.45 0 000 20.42v33.7A5.9 5.9 0 005.88 60h10.77a5.89 5.89 0 005.87-5.87V20.42a5.42 5.42 0 00-3.18-4.95zM10.89 2h1.77a.43.43 0 01.43.38l.72 5.74a.44.44 0 01-.43.49h-3.22a.44.44 0 01-.43-.49l.73-5.74a.43.43 0 01.43-.38zm-3.23 8.61H16a.43.43 0 01.43.36l.57 3.5a.43.43 0 01-.43.5H7.09a.43.43 0 01-.43-.5L7.23 11a.44.44 0 01.43-.39zm12.86 43.58A3.82 3.82 0 0116.71 58H5.82A3.82 3.82 0 012 54.19v-2.82a.43.43 0 01.43-.43h17.66a.43.43 0 01.43.43zM20.09 49H2.43a.43.43 0 01-.43-.46v-5.11a.44.44 0 01.39-.43h17.7a.43.43 0 01.43.43v5.11a.43.43 0 01-.43.46zm0-7.94H2.39A.43.43 0 012 40.6V20.78a3.81 3.81 0 013.09-3.73 2.92 2.92 0 01.69-.05H17.07a2.32 2.32 0 01.38.06 3.81 3.81 0 013.07 3.73V40.6a.43.43 0 01-.43.4z" />
  </svg>
);

SVG.propTypes = {
  style: PropTypes.object.isRequired,
};

export default SVG;
